module.exports = __webpack_public_path__ + "static/hero-mdr-95df04599387f9c0891c0a12e99485dd.png";